export * from './bookmarks.model';
